import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import App from "./App";

import { HelmetProvider } from "react-helmet-async";

// ------------------------------------------------------------
// Web Vitals
//
// Keep this enabled. It does not significantly affect your
// PageSpeed score in the current configuration.
// ------------------------------------------------------------

import reportWebVitals from "./reportWebVitals";

// ------------------------------------------------------------
// Application Root
// ------------------------------------------------------------

const root = ReactDOM.createRoot(
  document.getElementById("root"),
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);

// ------------------------------------------------------------
// Performance Monitoring
// ------------------------------------------------------------

reportWebVitals();